import type { OptionColor } from '@nexus/core';

/** Chip colours for select/status options, readable in light and dark mode. */
export const OPTION_CLASS: Record<OptionColor, string> = {
  gray: 'bg-zinc-200 text-zinc-800 dark:bg-zinc-700 dark:text-zinc-100',
  brown: 'bg-amber-200/70 text-amber-950 dark:bg-amber-900 dark:text-amber-100',
  orange: 'bg-orange-200 text-orange-950 dark:bg-orange-900 dark:text-orange-100',
  yellow: 'bg-yellow-200 text-yellow-950 dark:bg-yellow-800 dark:text-yellow-50',
  green: 'bg-green-200 text-green-950 dark:bg-green-900 dark:text-green-100',
  blue: 'bg-sky-200 text-sky-950 dark:bg-sky-900 dark:text-sky-100',
  purple: 'bg-violet-200 text-violet-950 dark:bg-violet-900 dark:text-violet-100',
  pink: 'bg-pink-200 text-pink-950 dark:bg-pink-900 dark:text-pink-100',
  red: 'bg-red-200 text-red-950 dark:bg-red-900 dark:text-red-100',
};

/** The small dot in front of a status value. */
export const DOT_CLASS: Record<OptionColor, string> = {
  gray: 'bg-zinc-500',
  brown: 'bg-amber-700',
  orange: 'bg-orange-500',
  yellow: 'bg-yellow-500',
  green: 'bg-green-600',
  blue: 'bg-sky-500',
  purple: 'bg-violet-500',
  pink: 'bg-pink-500',
  red: 'bg-red-500',
};
